import { gql } from '@apollo/client';
export const START_ASSESSMENT = gql(`
  mutation startAssessment($payload: [canx_start_assessment_input]!) {
    canx_start_assessment(data: $payload) {
      data {
        id
        candidate_id
        catalog_assessment_id
        external_id
        instance_status
        old_id
        workflow_candidate_step_id
        catalog_assessment {
          assessment_id
          catalog_id
          id
          assessment {
            description
            id
            level
            name
            status
            assessment_sections {
              allow_phone_interview
              allow_reattempt
              allow_review
              allow_skipping
              answer_time
              assessment_id
              external_id
              id
              is_shuffle_option
              is_shuffle_question
              name
              negative_mark
              positive_mark
              preparation_time
              section_type
              show_testcases
              is_show_answer
              sort_order
              max_section_time
              test {
                test_delivery_type
                test_provider {
                  id
                  name
                }
              }
            }
          }
        }
        sections {
          assessment_section_id
          completed_at
          external_id
          id
          instance_id
          invited_at
          is_completed
          last_active_at
          launch_code
          launch_url
          launch_username
          started_at
          questions
        }
      }
      error_message
      success
    }
  }
`);
export const START_SECTION = gql(`
  mutation startSection($payload: [canx_start_next_section_input]!) {
    canx_start_next_section(data: $payload) {
      error_message
      success
      data {
        assessment_section_id
        completed_at
        external_id
        id
        instance_id
        invited_at
        is_completed
        last_active_at
        launch_code
        launch_url
        launch_username
        questions
        started_at
        assessment_section {
          allow_phone_interview
          allow_reattempt
          allow_review
          allow_skipping
          answer_time
          assessment_id
          external_id
          id
          is_shuffle_option
          is_shuffle_question
          is_show_answer
          name
          negative_mark
          positive_mark
          preparation_time
          section_type
          show_testcases
          sort_order
          max_section_time
          test {
            test_delivery_type
            test_provider {
              id
              name
            }
          }
        }
      }
    }
  }
`);
export const GET_NEXT_QUESTION_BY_ID = gql(`
  mutation getNextQuestionById($section_id: Int!) {
    ae_get_next_question(section_id: $section_id) {
      error_message
      success
      data {
        answer_time
        content
        id
        is_shuffle
        level
        preparation_time
        question_bank_id
        is_correct
        question_allowed_language {
          value
        }
        question_choices {
          choice_order
          id
          value
        }
        question_languages {
          id
          language {
            value
          }
        }
        question_type {
          name
        }
      }
    }
  }
`);
export const GET_ALL_QUESTION = gql(`
  mutation getAllQuestion($section_id: Int!, $instance_id: Int!) {
    ae_get_question_list(instance_id: $instance_id, section_id: $section_id) {
      data {
        answer_time
        content
        is_shuffle
        id
        level
        preparation_time
        question_allowed_language {
          value
        }
        question_bank_id
        question_choices {
          choice_order
          id
          value
          is_correct
        }
        question_languages {
          id
          language {
            value
          }
        }
        question_type {
          name
        }
      }
      error_message
      success
    }
  }
`);
export const SAVE_ANSWERS = gql(`
  mutation saveAnswers($payload: [ae_save_answer!]) {
    ae_save_answer(data: $payload) {
      error_message
      success
      data {
        answered_at
        choice
        code_response
        id
        is_correct_choice
        question_id
        section_id
        text_response{
          doc {
            id
          }
        }
        time_to_response
      }
  }
  }
`);
export const CR_EXECUTE_CODE = gql(`
  mutation crExecuteCode($source_code: String!, $stdin: String, $language: String!) {
    cr_execute(language:$language , source: $source_code, stdin:$stdin) {
      execution_id
      updated_at
    }
  }
`);
export const SUBSCRIBE_CODE_EXECUTION = gql(`
  subscription subscribeCodeExecution($execution_id: Int!) {
    cr_execution(where: {id: { _eq: $execution_id } }) {
      memory_used
      std_out
      std_err
      cpu_time
      status
      id
    }
  }
`);
export const STOP_SECTION = gql(`
  mutation stopSection($section_id: Int!) {
    ae_stop_section(section_id: $section_id) {
      data {
        assessment_section_id
        completed_at
        external_id
        id
        instance_id
        invited_at
        is_completed
        last_active_at
        launch_code
        launch_url
        launch_username
        questions
        started_at
      }
      success
      error_message
    }
  }
`);
export const CREATE_TEST_INSTANCE = gql(`
  mutation createTestInstance($test_instance_id: Int!, $reattempt: Boolean! ){
    canx_create_test_instance(data: {test_instance_id: $test_instance_id, reattempt: $reattempt}){
      data {
        test_instance_id
        workflow_step_id
      }
      success
      error_message
    }
  }
`);
export const GET_TCF_MEASUREMENT = gql(`
query tsfMeasurement($test_instance_id:Int!) {
  ae_get_instance_score(data: {test_instance_id: $test_instance_id}) {
    data {
      id
      instance_id
      section_id
      section_configuration {
        id
        type
        assessment_section_id
      }
      measurement_attributes {
        id
        numerical_score
        ordinal {
          id
          label
        }
        section_configuration_attribute {
          id
          type
          attribute {
            attribute_type
            max_value
            min_value
            skill_id
            skill {
              name
            }
          }
        }
      }
    }
  }
}
`);
export const CANX_GET_APP_STATE = gql(`
  query getAppState($section_id: [Int]!) {
    canx_get_app_state(section_ids: $section_id){
      section_id
      state
    }
  }
`);
export const CANX_UPSERT_APP_STATE = gql(`
  mutation saveAppState($payload: [canx_upsert_app_state_input]!){
    canx_upsert_app_state(data: $payload) {
      data {
        section_id
        state
      }
      error_message
      success
    }
  }
`);
export const WFT_UPDATE_WORKFLOW_CANDIDATE_STEP_SYNC = gql(`
  mutation wftUpdateWorkflowCandidateStepSync($payload: [wft_update_workflow_candidate_step_input]!) {
    wft_update_workflow_candidate_step_sync(data: $payload) {
      data {
        id
      }
      error_message
      success
    }
  }
`);
export const GET_WORKFLOW_CANDIDATE_STEP_ID = gql(`
  query wftWorkflowCandidateStepId($test_instance_id: Int!) {
    wft_workflow_candidate_step(
      where: { test_instance_id: { _eq: $test_instance_id } }
    ) {
      workflowCandidate {
        workflow_candidate_steps {
          id
        }
      }
    }
  }
`);
// The step row that holds this test instance is the candidate's assessment step.
export const GET_WORKFLOW_CANDIDATE_STEP_ID_BY_TEST_INSTANCE = gql(`
  query wftWorkflowCandidateStepIdByTestInstance($test_instance_id: Int!) {
    wft_workflow_candidate_step(where: { test_instance_id: { _eq: $test_instance_id } }) {
      id
    }
  }
`);
export const GET_ASSESSMENT_REPORT_DETAILS = gql(`
  query res_find_resource($resource_type_id: Int!, $resource_id: Int) {
    res_find(resource_type_id: $resource_type_id, resource_id: $resource_id) {
      data
    }
  }
`);
